"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var followers = {
  total: 96,
  potencial: 96,
  potentialDiversities: [{
    diversityName: 'Bigender',
    potential: 2,
    total: 4,
    percentage: 50
  }, {
    diversityName: 'Buddhism',
    potential: 1,
    total: 2,
    percentage: 50
  }, {
    diversityName: 'Christianity',
    potential: 1,
    total: 4,
    percentage: 25
  }, {
    diversityName: 'Female (Cisgender)',
    potential: 5,
    total: 8,
    percentage: 62.5
  }, {
    diversityName: 'Gender Neutral/Agender',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Hispanic or LatinX',
    potential: 1,
    total: 3,
    percentage: 33.33333333333333
  }, {
    diversityName: 'Intersex',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Judaism',
    potential: 1,
    total: 2,
    percentage: 50
  }, {
    diversityName: 'Male (Cisgender)',
    potential: 1,
    total: 13,
    percentage: 7.6923076923076925
  }, {
    diversityName: 'Other',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Other',
    potential: 2,
    total: 3,
    percentage: 66.66666666666666
  }, {
    diversityName: 'White',
    potential: 1,
    total: 10,
    percentage: 10
  }],
  percentage: 100
};
var applicants = {
  total: 231,
  potencial: 231,
  potentialDiversities: [{
    diversityName: 'Bigender',
    potential: 2,
    total: 4,
    percentage: 50
  }, {
    diversityName: 'Buddhism',
    potential: 1,
    total: 2,
    percentage: 50
  }, {
    diversityName: 'Christianity',
    potential: 1,
    total: 4,
    percentage: 25
  }, {
    diversityName: 'Female (Cisgender)',
    potential: 5,
    total: 8,
    percentage: 62.5
  }, {
    diversityName: 'Gender Neutral/Agender',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Hispanic or LatinX',
    potential: 1,
    total: 3,
    percentage: 33.33333333333333
  }, {
    diversityName: 'Intersex',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Judaism',
    potential: 1,
    total: 2,
    percentage: 50
  }, {
    diversityName: 'Male (Cisgender)',
    potential: 1,
    total: 13,
    percentage: 7.6923076923076925
  }, {
    diversityName: 'Other',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Other',
    potential: 2,
    total: 3,
    percentage: 66.66666666666666
  }, {
    diversityName: 'White',
    potential: 1,
    total: 10,
    percentage: 10
  }],
  percentage: 100
};
var profileViews = {
  total: 100,
  potencial: 75,
  potentialDiversities: [{
    diversityName: 'Bigender',
    potential: 2,
    total: 4,
    percentage: 50
  }, {
    diversityName: 'Buddhism',
    potential: 1,
    total: 2,
    percentage: 50
  }, {
    diversityName: 'Christianity',
    potential: 1,
    total: 4,
    percentage: 25
  }, {
    diversityName: 'Female (Cisgender)',
    potential: 5,
    total: 8,
    percentage: 62.5
  }, {
    diversityName: 'Gender Neutral/Agender',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Hispanic or LatinX',
    potential: 1,
    total: 3,
    percentage: 33.33333333333333
  }, {
    diversityName: 'Intersex',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Judaism',
    potential: 1,
    total: 2,
    percentage: 50
  }, {
    diversityName: 'Male (Cisgender)',
    potential: 1,
    total: 13,
    percentage: 7.6923076923076925
  }, {
    diversityName: 'Other',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Other',
    potential: 2,
    total: 3,
    percentage: 66.66666666666666
  }, {
    diversityName: 'White',
    potential: 1,
    total: 10,
    percentage: 10
  }],
  percentage: 75
};
var oppViews = {
  total: 379,
  potencial: 379,
  potentialDiversities: [{
    diversityName: 'Bigender',
    potential: 2,
    total: 4,
    percentage: 50
  }, {
    diversityName: 'Buddhism',
    potential: 1,
    total: 2,
    percentage: 50
  }, {
    diversityName: 'Christianity',
    potential: 1,
    total: 4,
    percentage: 25
  }, {
    diversityName: 'Female (Cisgender)',
    potential: 5,
    total: 8,
    percentage: 62.5
  }, {
    diversityName: 'Gender Neutral/Agender',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Hispanic or LatinX',
    potential: 1,
    total: 3,
    percentage: 33.33333333333333
  }, {
    diversityName: 'Intersex',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Judaism',
    potential: 1,
    total: 2,
    percentage: 50
  }, {
    diversityName: 'Male (Cisgender)',
    potential: 1,
    total: 13,
    percentage: 7.6923076923076925
  }, {
    diversityName: 'Other',
    potential: 1,
    total: 1,
    percentage: 100
  }, {
    diversityName: 'Other',
    potential: 2,
    total: 3,
    percentage: 66.66666666666666
  }, {
    diversityName: 'White',
    potential: 1,
    total: 10,
    percentage: 10
  }],
  percentage: 100
};
var _default = {
  followers: followers,
  applicants: applicants,
  profileViews: profileViews,
  oppViews: oppViews
};
exports.default = _default;